module.exports = __webpack_public_path__ + "static/custom-systems-building-1aee868eddf7191b556163c6ae453526.svg";